import React, { useState, useEffect } from "react";
import { withFormik, Form as Formiker, Field as Fieldmik } from "formik";
import * as yup from "yup";
import {
    Form as FormUi,
    Container, TextArea, Dropdown
} from "semantic-ui-react";
import ReadAxios from "../../axiosComponent/read";
import { connect } from "react-redux";
import {
    successAlertDispatcher,
    errorAlertDispatcher,
} from "../../../redux/actions/alertAction";
import UpdateAxios from "../../axiosComponent/update";
import CreateAxios from "../../axiosComponent/create";
import { translate } from "react-i18next";
import { isEmpty } from "lodash";
import { INVALID_FIELDS, REQUIRED_FIELDS } from "../../../utils/validationConstant";
import { customerNo } from "../../../utils/constant";
import cogoToast from "cogo-toast";
import MandatoryMark from "../../common/mandatorymark";

const currentUser = Number(customerNo);

const InsertCha = ({ values, setFieldValue, touched, errors, t }) => {

    return (
        <React.Fragment>
            <Formiker>
                <div className="container-fluid animated slideInDown pad w3-white">
                    <div className="m-3 pl-3">
                        <div className="ui form">
                            <FormUi.Group inline>
                                <FormUi.Field width={2}>
                                    <label className="labelName">
                                        {"CHA Code"}
                                    </label>
                                </FormUi.Field>
                                <FormUi.Field className="display-grid-center-imp" width={4} error={touched.chaCode && errors.chaCode ? true : false}                >
                                    <Fieldmik
                                        type="text"
                                        className="ui input"
                                        name="chaCode"
                                        placeholder={"CHA Code"}
                                    />
                                    {touched.chaCode && errors.chaCode ? (
                                        <div className="error-msg">
                                            {errors.chaCode}
                                        </div>
                                    ) : null}
                                </FormUi.Field>


                                <FormUi.Field width={2}>
                                    <label className="labelName">
                                        {"CHA Name"}{" "}<MandatoryMark/>
                                    </label>
                                </FormUi.Field>
                                <FormUi.Field className="display-grid-center-imp" width={4} error={touched.chaName && errors.chaName ? true : false}                >
                                    <Fieldmik
                                        type="text"
                                        className="ui input"
                                        name="chaName"
                                        placeholder={"CHA Name"}
                                    />
                                    {touched.chaName && errors.chaName ? (
                                        <div className="error-msg">
                                            {errors.chaName}
                                        </div>
                                    ) : null}
                                </FormUi.Field>

                            </FormUi.Group>
                        </div>
                    </div>
                </div>
                <Container className="p-3" textAlign="center">
                    <button
                        className="w3-button w3-blue w3-hover-blue w3-round w3-small"
                        type="submit"
                    >
                        Submit
                    </button>
                </Container>
            </Formiker>
        </React.Fragment>
    );
};

const FormikCha = withFormik({
    validationSchema: yup.object({
        chaCode: yup.string().nullable(),
        chaName: yup.string().required(REQUIRED_FIELDS.FIELD_IS_REQUIRED),
    }),
    enableReinitialize: true,
    mapPropsToValues: (props) => {
        return {
            chaCode: props.editData.CHACode || "",
            chaName: props.editData.CHAName || "",
        };
    },
    async handleSubmit(values, { props }) {
        if (props.editData.CHAId) {
            UpdateAxios({
                url: "cha",
                payload: { ...values },
                uniqueId: props.editData.CHAId,
            })
                .then((res) => {
                    if (res.data.status === 204) {
                        cogoToast.error(res.data.message);
                    }
                    else {
                        let alert = {
                            type: "success",
                            messageHeader: "Success",
                            messageBody: res.data.message,
                        };
                        props.successAlertDispatcher(alert);
                        props.onFormSubmit();
                    }
                })
                .catch((err) => {
                    let alert = {
                        type: "error",
                        messageHeader: "Error",
                        messageBody: err.data.message,
                    };
                    console.log(err);
                    props.errorAlertDispatcher(alert);
                });
        } else {
            CreateAxios({
                url: "cha",
                payload: { ...values },
            })
                .then((res) => {
                    if (res.data.status === 204) {
                        cogoToast.error(res.data.message);
                    }
                    else {
                        let alert = {
                            type: "success",
                            messageHeader: "Success",
                            messageBody: res.data.message,
                        };
                        props.successAlertDispatcher(alert);
                        props.onFormSubmit();
                    }
                })
                .catch((err) => {
                    console.log("error cha", err);
                    let alert = {
                        type: "error",
                        messageHeader: "Error",
                        messageBody: err.data.message,
                    };
                    props.errorAlertDispatcher(alert);
                });
        }

    },
})(InsertCha);

export default connect(null, { successAlertDispatcher, errorAlertDispatcher })(
    translate("cha")(FormikCha)
);
